import { Session } from '@shared/app/scripts/services/session';

/**
 * A directive which can be used to show or hide an element based on a user's
 * tenant type. This directive relies on the {@link sharedModule.currentSession}
 * to contain a tenant retail boolean.
 *
 * Note! This directive uses the same css as {@link
 * coreModule.directive:swAllowed}, and they collide. Workaround for this is to
 * put them on separate DOM elements, with the more important outside.
 *
 * # HTML Example
 * <code><pre>
 * <button sw-if-retail>Button that only retail users will see</button>
 * </pre></code>
 */
angular.module('coreModule').directive('swIfRetail', (session: Session) => ({
  restrict: 'A',

  link: function (scope, element) {
    session.current$.subscribe((sessionCurrent) => {
      if (sessionCurrent.retail) {
        element.removeClass('ng-hide');
      } else {
        element.addClass('ng-hide');
      }
    });
  },
}));
